module.exports = __webpack_public_path__ + "img/рз_21.bd625722.png";